import React, { useContext, useEffect, useReducer, useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { Typography } from "@mui/material";
import DateForm from "../../Components/DateForm/DateForm";
import { GetMemberDashboardDetails } from "../../Helpers/APIEndPoints/EndPoints";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import InitialDeposite from "./InitialDeposite";
import "./SanjivanSuvidha.css";
import { useNavigate } from "react-router-dom";

const SubscriptionPlan = (props) => {
  const { memberData, memberDoj } = props;
  const [modalShow, setModalShow] = React.useState(false);
  // const [memberData, setMemberData] = useState(null);
  // const [memberDoj, setMemberDoj] = useState(null);
  const [dashboardData, setDashboardData] = useState({
    cdAmount: 0,
    shareAmount: 0,
    shareAmount2: 0,
    fdAmount: 0,
    afdAmount: 0,
    cdMaxLimit: 0,
    shareMaxLimit: 0,
    shareMaxLimit2: 0,
    fdMaxLimit: 0,
    afdMaxLimit: 0,
    doj: null,
    initDeposite: 0,
    mbfAmount:0,
    mbfMaxLimit:0
  });
  let navigate = useNavigate();
  const [toDate, setToDate] = useState(null);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const context = getContext();
  let MemberId = context.MemberId;
  const calculatePercentage = (amount, maxLimit) => {
    return (amount / maxLimit) * 100;
  };

  useEffect(() => {
    if (memberData && memberDoj) {
      setDashboardData({
        ...memberData,
        doj: memberDoj,
        cdAmount: memberData.CD,
        shareAmount: memberData.Share1,
        shareAmount2: memberData.Share2,
        fdAmount: memberData.FD,
        afdAmount: memberData.AdditionalFD,
        cdMaxLimit: memberData.CDMax_Limit,
        shareMaxLimit: memberData.Share1MaxLimit,
        shareMaxLimit2: memberData.Share2MaxLimit,
        fdMaxLimit: memberData.FDMax_Limit,
        afdMaxLimit: memberData.AdditionalFDMax_Limit,
        initDeposite: memberData.InitialDeposit,
        mbfAmount:memberData.MBF,
        mbfMaxLimit:memberData.MBFMaxLimit
      });
     
    }
  }, [memberData, memberDoj]);

  // const getDashboardData = async () => {
  //   showLoader();
  //   try {
  //     const obj = { MemberId };
  //     const resp = await APICall(GetMemberDashboardDetails, obj);

  //     if (resp?.Data?.MemberSubscriptionPlanList?.length > 0) {
  //       const memberData = resp?.Data?.MemberSubscriptionPlanList[0];
  //       const memberDoj = resp?.Data?.DOJ;

  //       setDashboardData({
  //         ...memberData,
  //         doj: memberDoj,
  //         cdAmount: memberData.CD,
  //         shareAmount: memberData.Share1,
  //         shareAmount2: memberData.Share2,
  //         fdAmount: memberData.FD,
  //         afdAmount: memberData.AdditionalFD,
  //         cdMaxLimit: memberData.CDMax_Limit,
  //         shareMaxLimit: memberData.Share1MaxLimit,
  //         shareMaxLimit2: memberData.Share2MaxLimit,
  //         fdMaxLimit: memberData.FDMax_Limit,
  //         afdMaxLimit: memberData.AdditionalFDMax_Limit,
  //         initDeposite: memberData.InitialDeposit,
  //       });
  //       forceUpdate();
  //     } else {
  //       console.log("There is no data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching dashboard data:", error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  // useEffect(() => {
  //   if (MemberId) {
  //     getDashboardData();
  //   }
  // }, [MemberId]);

  const handleRoleSubmit = () => { };

  return (
    <>
      <div className="my-card">
        <InitialDeposite
          show={modalShow}
          onHide={() => setModalShow(false)}
          handleRoleSubmit={handleRoleSubmit}
          initDeposite={dashboardData.initDeposite}
        />
        <span className="route-title-card">Subscription Plan</span>
        <div className="row d-flex flex-row justify-content-center align-items-center flex-wrap my-2">
          <div className="col-md-5 intDep">
            Initial Deposit : {dashboardData.initDeposite}
            {/* <button onClick={() => setModalShow(true)}>
            <i className="fas fa-edit"></i>
          </button> */}
          </div>
          <div className="col-md-7 d-flex">
            <span className="date-jng">Date of joining :</span>
            <span>
              <DateForm
                isDisabled={true}
                value={dashboardData.doj}
                onChange={(e) => setToDate(e)}
                placeholder="DD-MM-YYYY"
              />
            </span>
          </div>
        </div>
        <table className="table" >
          <thead>
            <tr>
              <th className="custom-header">Opening Balance</th>
              <th style={{ width: "44%" }} className="custom-header"></th>
              <th style={{verticalAlign:"top"}} className="custom-header">Maximum</th>
              <th className="custom-header">Amount Till Date</th>
            </tr>
          </thead>
          <tbody className="custome-body">
            {/* SHARE 1 */}
            <tr>
              <td>SHARE 1:</td>
              <td>
                <LinearProgress
                  variant="determinate"
                  value={calculatePercentage(
                    dashboardData.shareAmount,
                    dashboardData.shareMaxLimit
                  )}
                  sx={{ backgroundColor: "#e0e0e0", height: 8, borderRadius: 4 }}
                  title={`Share 1 Amount: ${dashboardData.shareAmount}`}
                />
              </td>
              <td>Rs {dashboardData.shareMaxLimit}</td>
              <td>Rs {dashboardData.shareAmount}</td>
            </tr>

            {/* SHARE 2 */}
            <tr>
              <td>SHARE 2:</td>
              <td>
                <LinearProgress
                  variant="determinate"
                  value={calculatePercentage(
                    dashboardData.shareAmount2,
                    dashboardData.shareMaxLimit2
                  )}
                  sx={{ backgroundColor: "#e0e0e0", height: 8, borderRadius: 4 }}
                  title={`Share 2 Amount: ${dashboardData.shareAmount2}`}
                />
              </td>
              <td>Rs {dashboardData.shareMaxLimit2}</td>
              <td>Rs {dashboardData.shareAmount2}</td>
            </tr>

            {/* CD */}
            <tr>
              <td>CD:</td>
              <td>
                <LinearProgress
                  variant="determinate"
                  value={calculatePercentage(
                    dashboardData.cdAmount,
                    dashboardData.cdMaxLimit
                  )}
                  sx={{ backgroundColor: "#e0e0e0", height: 8, borderRadius: 4 }}
                  title={`CD Amount: ${dashboardData.cdAmount}`}
                />
              </td>
              <td>Rs {dashboardData.cdMaxLimit}</td>
              <td>Rs {dashboardData.cdAmount}</td>
            </tr>

            {/* FD */}
            <tr>
              <td>FD:</td>
              <td>
                <LinearProgress
                  variant="determinate"
                  value={calculatePercentage(
                    dashboardData.fdAmount,
                    dashboardData.fdMaxLimit
                  )}
                  sx={{ backgroundColor: "#e0e0e0", height: 8, borderRadius: 4 }}
                  title={`FD Amount: ${dashboardData.fdAmount}`}
                />
              </td>
              <td>Rs {dashboardData.fdMaxLimit}</td>
              <td>Rs {dashboardData.fdAmount}</td>
            </tr>

            {/* AFD */}
            <tr>
              <td>AFD:</td>
              <td>
                <LinearProgress
                  variant="determinate"
                  value={calculatePercentage(
                    dashboardData.afdAmount,
                    dashboardData.afdMaxLimit
                  )}
                  sx={{ backgroundColor: "#e0e0e0", height: 8, borderRadius: 4 }}
                  title={`AFD Amount: ${dashboardData.afdAmount}`}
                />
              </td>
              <td>Rs {dashboardData.afdMaxLimit}</td>
              <td>Rs {dashboardData.afdAmount}</td>
            </tr>
            <tr>
              <td>MBF:</td>
              <td>
                <LinearProgress
                  variant="determinate"
                  value={calculatePercentage(
                    dashboardData.mbfAmount,
                    dashboardData.mbfMaxLimit
                  )}
                  sx={{ backgroundColor: "#e0e0e0", height: 8, borderRadius: 4 }}
                  title={`AFD Amount: ${dashboardData.mbfAmount}`}
                />
              </td>
              <td>Rs {dashboardData.mbfMaxLimit}</td>
              <td>Rs {dashboardData.mbfAmount}</td>
            </tr>
          </tbody>
        </table>


        {/* <span className="route-title-card">Opening Balance</span>

        <div className="row balance d-flex flex-row justify-content-center align-items-center flex-wrap my-3">
          <div className="col-md-2">
            <Typography variant="subtitle1" component="div">
              SHARE 1:
            </Typography>
          </div>
          <div className="col-md-8">
            <LinearProgress
              variant="determinate"
              value={calculatePercentage(
                dashboardData.shareAmount,
                dashboardData.shareMaxLimit
              )}
              sx={{ backgroundColor: "#e0e0e0" }}
              style={{ maxWidth: "100%" }}
              title={`Share 1 Amount: ${dashboardData.shareAmount}`}
            />
          </div>
          <div className="col-md-2">
            {" "}
            <p>{dashboardData.shareMaxLimit} Rs</p>
          </div>
        </div>

        <div className="row balance d-flex flex-row justify-content-center align-items-center flex-wrap my-3">
          <div className="col-md-2">
            <Typography variant="subtitle1" component="div">
              SHARE 2:
            </Typography>
          </div>
          <div className="col-md-8">
            <LinearProgress
              variant="determinate"
              value={calculatePercentage(
                dashboardData.shareAmount2,
                dashboardData.shareMaxLimit2
              )}
              sx={{ backgroundColor: "#e0e0e0" }}
              style={{ maxWidth: "100%" }}
              title={`Share 2 Amount: ${dashboardData.shareAmount2}`}
            />
          </div>
          <div className="col-md-2">
            <p>{dashboardData.shareMaxLimit2} Rs</p>
          </div>
        </div>

        <div className="row balance d-flex flex-row justify-content-center align-items-center flex-wrap">
          <div className="col-md-2">
            <Typography variant="subtitle1" component="div">
              CD:
            </Typography>
          </div>
          <div className="col-md-8">
            <LinearProgress
              variant="determinate"
              value={calculatePercentage(
                dashboardData.cdAmount,
                dashboardData.cdMaxLimit
              )}
              sx={{ backgroundColor: "#e0e0e0" }}
              style={{ maxWidth: "100%" }}
              title={`CD Amount: ${dashboardData.cdAmount}`}
            />
          </div>
          <div className="col-md-2">
            <p>{dashboardData.cdMaxLimit} Rs</p>
          </div>
        </div>

        <div className="row balance d-flex flex-row justify-content-center align-items-center flex-wrap my-3">
          <div className="col-md-2">
            <Typography variant="subtitle1" component="div">
              FD:
            </Typography>
          </div>
          <div className="col-md-8">
            <LinearProgress
              variant="determinate"
              value={calculatePercentage(
                dashboardData.fdAmount,
                dashboardData.fdMaxLimit
              )}
              sx={{ backgroundColor: "#e0e0e0" }}
              style={{ maxWidth: "100%" }}
              title={`FD Amount: ${dashboardData.fdAmount}`}
            />
          </div>
          <div className="col-md-2">
            {" "}
            <p>{dashboardData.fdMaxLimit} Rs</p>
          </div>
        </div>

        <div className="row balance d-flex flex-row justify-content-center align-items-center flex-wrap my-3">
          <div className="col-md-2">
            <Typography variant="subtitle1" component="div">
              AFD:
            </Typography>
          </div>
          <div className="col-md-8">
            <LinearProgress
              variant="determinate"
              value={calculatePercentage(
                dashboardData.afdAmount,
                dashboardData.afdMaxLimit
              )}
              sx={{ backgroundColor: "#e0e0e0" }}
              style={{ maxWidth: "100%" }}
              title={`AFD Amount: ${dashboardData.afdAmount}`}
            />
          </div>
          <div className="col-md-2">
            {" "}
            <p>{dashboardData.afdMaxLimit} Rs</p>
          </div>
        </div> */}


        <div className="text-center  mt-2">
          <button
            className="text-center btn-submit"
            onClick={() => {
              navigate("/SubscriptionPlanView");
            }}
          >
            <i className="fas fa-eye"></i> View Details
          </button>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPlan;
